import { FileProviderViewState } from 'owa-fileprovider-store';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { FileProvidersFilter } from '../store/schema/FileProvidersFilter';

const fileProvidersFilterMap = {};
fileProvidersFilterMap[FileProvidersFilter.InsertLinkBusiness] = [
    AttachmentDataProviderType.OneDrivePro,
];

fileProvidersFilterMap[FileProvidersFilter.InsertLinkConsumer] = [
    AttachmentDataProviderType.OneDriveConsumer,
    AttachmentDataProviderType.Dropbox,
    AttachmentDataProviderType.Box,
    AttachmentDataProviderType.GDrive,
];

export function filterBasedOnFileProvidersFilter(
    fileProvidersFilter: FileProvidersFilter
): (viewState: FileProviderViewState) => boolean {
    return (viewState: FileProviderViewState) => {
        if (fileProvidersFilter === undefined || fileProvidersFilter === FileProvidersFilter.None) {
            return true;
        }

        return fileProvidersFilterMap[fileProvidersFilter].some(
            provider => provider === viewState.type
        );
    };
}
